import GetFranchiseListDummyData from "../../../dummy/GetFranchiseListDummyData.json";
import GetFranchiseInfoDummyData from "../../../dummy/GetFranchiseInfoDummyData.json";
import SaveFranchiseDummyData from "../../../dummy/SaveFranchiseDummyData.json";
import UpdateFranchiseDummyData from "../../../dummy/UpdateFranchiseDummyData.json";
import DeleteFranchiseDummyData from "../../../dummy/DeleteFranchiseDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import FranchiseDto from "../dto/franchise/FranchiseDto";
import FranchiseListDto from "../dto/franchise/FranchiseListDto";
import FranchiseSaveRespDto from "../dto/franchise/FranchiseSaveRespDto";

class FakeFranchiseApi {
    getFranchiseList = async ({
        page = 1,
        pageSize = 20,
        franchiseCode,
        franchiseName,
    }: {
        page?: number;
        pageSize?: number;
        franchiseCode?: string;
        franchiseName?: string;
    } = {}): Promise<SuccessResponse<FranchiseListDto>> => {
        const curPage = Number(page) || 1;
        const size = Math.min(Number(pageSize) || 20, 50);

        let all = GetFranchiseListDummyData.result.franchiseInfo;
        if (franchiseCode) {
            all = all.filter((item) => (item.franchiseCode ?? "").toLowerCase().includes(franchiseCode.toLowerCase()));
        }
        if (franchiseName) {
            all = all.filter((item) => (item.name ?? "").toLowerCase().includes(franchiseName.toLowerCase()));
        }

        const totalCount = all.length;
        const totalPage = Math.max(1, Math.ceil(totalCount / size));
        const start = (curPage - 1) * size;
        const franchiseInfo = all.slice(start, start + size);

        return {
            ...GetFranchiseListDummyData,
            result: {
                page: { pageSize: size, curPage, totalPage, totalCount },
                franchiseInfo,
            },
        };
    };

    saveFranchise = async (): Promise<SuccessResponse<FranchiseSaveRespDto>> => {
        return SaveFranchiseDummyData;
    };

    getFranchiseInfo = async (): Promise<SuccessResponse<FranchiseDto>> => {
        return GetFranchiseInfoDummyData;
    };

    updateFranchise = async (): Promise<SuccessResponse<FranchiseSaveRespDto>> => {
        return UpdateFranchiseDummyData;
    };

    deleteFranchise = async (): Promise<SuccessResponse<string>> => {
        return DeleteFranchiseDummyData;
    };

    checkFranchiseCode = async (): Promise<SuccessResponse<FranchiseDto>> => {
        return GetFranchiseInfoDummyData;
    };
}

export default FakeFranchiseApi;
